
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import chart from '@/views/calculator/components/chart.vue';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import store from '@/store';

@Options({
    components: {
        chart
    }
})
export default class SummaryCharts extends Vue {

    @Prop() model: OM.SummaryVM;

    created(){}

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    get companyManagementScoringCat() {
        return VM.ScoringCategories.CompanyManagement;
    }
    get productScoringCat() {
        return VM.ScoringCategories.Product;
    }
    get socialResponsabilityScoringCat() {
        return VM.ScoringCategories.SocialResponsibility;
    }

}
